export enum UniteResults {
  SPARK = 'c2fe4551-31a2-4534-ab24-24a6edba8f93',
  MONSTERS = '44afe852-af8e-45c3-9689-504040eb9c27',
  BUSY = 'f88a2dae-a305-4268-ae27-959ea44e1cd0',
  SCARED = 'e2e4a316-030b-4f44-93b2-b1b2be4e1aa1',
}
